import classes from "./Introduction.module.css";
import React, { useEffect, useContext, useState } from "react";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import RemoteConfig from "../../services/RemoteConfig";
import AuthContext from "../../store/auth-context";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

//ABOUT US
const Introduction = (props) => {
  const { introductionRef } = props || {};
  const { isFetchActivateRemoteConfig } = useContext(AuthContext);
  const [image, setImage] = useState(images.nail11);
  const isMobile = useCheckIsMobile();

  // useEffect(() => {
  //   const introduction_image = RemoteConfig.getConfigValue("introduction_image");
  //   introduction_image && setImage(introduction_image);
  // }, [isFetchActivateRemoteConfig]);

  return (
    <div ref={introductionRef} className={classes.introduction}>
      <div className={classes.introHeader}>
        <h2 className={classes.cursiveText}>{NAIL_SHOP_INFO.name}</h2>
      </div>
      <div className={classes.rowWrapper}>
        <img alt={"Intro"} src={image} className={classes.introImg} />
        <div className={classes.introTextContainer}>
          <div>
            <h1>{"Welcome to Refined Beauty Nails!"}</h1>
            <h3 className={classes.greyIntroTextContainer}>
            HEALTHY NAILS, HAPPY YOU
            </h3>
          </div>
          <p className={classes.greyIntroTextContainer}>
            Do you believe that beautiful, healthy nails—paired with complete
            relaxation—can bring you joy and true confidence? At Refined Beauty
            Nails, we wholeheartedly believe so. Guided by our philosophy,
            “HEALTHY NAILS, HAPPY YOU,” we are dedicated to delivering a
            luxurious nail care experience that not only enhances your
            appearance, but also nurtures your wellbeing and soothes your
            senses.
          </p>
          <p className={classes.greyIntroTextContainer}>
            Step into the modern, tranquil sanctuary of Refined Beauty Nails,
            and you’ll be welcomed by a team of highly skilled, passionate
            professionals. We stay at the forefront of beauty trends and use
            only premium products from leading brands such as THE GEL BOTTLE,
            OPI, IBX, CHISEL, MD, DC—ensuring each set of nails is not only
            stunning, but also a true reflection of your unique style.
          </p>

          <p className={classes.greyIntroTextContainer}>
  While enjoying your manicure or pedicure, indulge in the comfort of our PSD LUXE massage chairs. 
  With a range of gentle yet effective massage programs, they provide soothing relief from tension 
  and physical fatigue, leaving you refreshed and recharged.
  <br /><br />
  At Refined Beauty Nails, we offer an array of tailored services to meet your every need:
  <br /><br />• Classic and advanced hand & foot care: Including nail trimming, shaping, and exfoliation, 
  all while you relax in our state-of-the-art Lexor Mystique pedicure chairs or the luxurious PSD LUXE massage chairs.
  <br />• Gel and classic polish: A rich palette of vibrant and elegant colors from top brands like OPI and THE GEL BOTTLE.
  <br />• Nail art and custom design: From minimalistic elegance to intricate, eye-catching creations—our nail artists bring your vision to life.
  <br />• Acrylic and gel nail extensions: Perfectly shaped and lengthened nails using top-quality products from CHISEL and MD.
  <br />• Intensive nail repair and care: Strengthen and restore fragile or damaged nails with professional IBX treatments.
  <br />• Relaxing foot massage therapy: A rejuvenating experience using warm towels and hot stones to relieve tension, 
  reduce fatigue, and boost circulation—leaving your feet silky soft and renewed.
</p>

          <BookNowBtn />
        </div>
      </div>
    </div>
  );
};

export default Introduction;
